import React, { useRef, useState } from "react";
import { Modal, Button, Input } from "antd";
import { MailOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";

import Modalenter from "./modalEnterCode";
import { actionCorreo } from "../../redux/actions/login/login";
import { notify } from "../ui";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function Home({ show, setShow }) {
  const [correo, setCorreo] = useState("");
  const [showenter, setShowenter] = useState(false);
  const [clave, setClave] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const dispatch = useDispatch();
  const inputRef = useRef(null);

  const callbackError = () => {
    notify.error("No se pudo continuar", "El correo no existe o no está registrado.");
  };

  const submit = async (e) => {
    e?.preventDefault?.();

    if (!correo) {
      setError("El correo es obligatorio.");
      return;
    }
    if (!EMAIL_RE.test(correo)) {
      setError("Escribe un correo válido.");
      return;
    }
    setError("");
    setLoading(true);

    dispatch(
      actionCorreo(
        { email: correo },
        (value) => {
          setLoading(false);

          if (!value?.status) {
            callbackError();
            return;
          }

          setShow(false);
          setShowenter(true);
          setClave(value.clave);
        },
        () => {
          setLoading(false);
          callbackError();
        }
      )
    );
  };

  return (
    <>
      <Modalenter show={showenter} setShow={setShowenter} clave={clave} correo={correo} />

      <Modal
        open={show}
        onCancel={() => !loading && setShow(false)}
        centered
        maskClosable={!loading}
        closable={!loading}
        title={
          <div className="d-flex align-items-start gap-3">
            <div
              className="rounded-3 bg-primary-subtle d-flex align-items-center justify-content-center"
              style={{ width: 40, height: 40, flexShrink: 0 }}
            >
              <i className="bi bi-lock fs-5" />
            </div>
            <div>
              <div className="mb-1">Recuperación de contraseña</div>
              <p className="text-secondary mb-0" style={{ fontWeight: 400 }}>
                Ingresa el correo asociado a tu cuenta para continuar.
              </p>
            </div>
          </div>
        }
        footer={[
          <Button key="cancel" onClick={() => setShow(false)} disabled={loading}>
            Cancelar
          </Button>,
          <Button key="submit" type="primary" loading={loading} onClick={submit}>
            Enviar
          </Button>,
        ]}
      >
        <form onSubmit={submit}>
          <div className="mb-2">
            <label className="d-block mb-1">Correo electrónico</label>
            <Input
              ref={inputRef}
              type="email"
              size="large"
              prefix={<MailOutlined />}
              placeholder="tu_correo@dominio.com"
              maxLength={100}
              autoFocus
              disabled={loading}
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
              status={error ? "error" : ""}
            />
            {error && <div className="text-danger small mt-1">{error}</div>}
          </div>
          <small className="text-secondary">
            Si no recuerdas tu correo, contacta al administrador del sistema.
          </small>
        </form>
      </Modal>
    </>
  );
}

export default Home;
